"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.composeFaultsMiddleware = exports.isFaultsTable = void 0;
var faults_1 = __importDefault(require("../constants/faults"));
var faults_slice_1 = require("../slices/faults.slice");
var faults_api_1 = __importDefault(require("../apis/faults.api"));
var app_1 = __importDefault(require("../constants/app"));
var modal_slice_1 = require("../slices/modal.slice");
var isFaultsTable = function (action) { return action.payload.tableId === app_1.default.TABLE.FAULTS.TABLE_ID; };
exports.isFaultsTable = isFaultsTable;
var composeFaultsMiddleware = function (faultsAdapter) { return function (api) { return function (next) { return function (action) {
    switch (action.type) {
        // TODO: Later, this should trigger on the action where the vehicle info history page is mounted
        // TODO: Should also trigger on when the main faults page is loaded, when we refactor that
        case faults_slice_1.FAULTS_SET_SELECTED_FAULT_FOR_DETAILS_MODAL:
            next(action);
            // reset error state when we set a new fault for the modal
            (0, faults_slice_1.faultsSetFaultDetailsErrorAction)(false)(api.dispatch);
            break;
        case faults_slice_1.FAULTS_ADD_FLAG_ACTION:
            faultsAdapter.handleAddFlagAction(api)(action);
            next(action);
            break;
        case faults_slice_1.FAULTS_REMOVE_FLAG_ACTION:
            faultsAdapter.handleRemoveFlagAction(api)(action);
            next(action);
            break;
        case faults_slice_1.FAULTS_REQUEST_FAULT_DETAILS:
            faultsAdapter.handleRequestFaultDetailsAction(api)(action);
            next(action);
            break;
        case faults_slice_1.FAULTS_REQUEST_FAULT_DETAILS_BY_ROW_KEY:
            faultsAdapter.handleRequestFaultDetailsByRowKeyAction(api)(action);
            next(action);
            break;
        case faults_slice_1.FAULTS_REQUEST_FAULT_DETAILS_BY_STREAMING_SOURCE_AND_ID:
            faultsAdapter.handleRequestFaultDetailsByStreamingSourceAndIdAction(api)(action);
            next(action);
            break;
        case faults_slice_1.FAULTS_REQUEST_FAULT_RING_BUFFER_DATA:
            faultsAdapter.handleRequestRingBufferDataAction(api)(action);
            next(action);
            break;
        case faults_slice_1.FAULTS_CONFIRM_REQUEST_TOGGLE_IS_RESOLVED:
            (0, modal_slice_1.openModalAction)(faults_1.default.FAULTS_CONFIRM_REQUEST_TOGGLE_IS_RESOLVED)(api.dispatch);
            next(action);
            break;
        case faults_slice_1.FAULTS_REQUEST_TOGGLE_IS_RESOLVED:
            faultsAdapter.putToggleFaultIsResolved(api)(action.payload);
            next(action);
            break;
        case faults_slice_1.FAULTS_TOGGLE_IS_RESOLVED_SUCCESS:
            (0, modal_slice_1.closeModalAction)()(api.dispatch);
            next(action);
            break;
        case faults_slice_1.FAULTS_TOGGLE_IS_RESOLVED_ERROR:
            (0, modal_slice_1.openModalAction)(faults_1.default.ERROR)(api.dispatch);
            next(action);
            break;
        case faults_slice_1.FAULTS_NEEDS_INBOX_DATA:
            faultsAdapter.handleNeedsFaultsInboxDataAction(api)(action);
            next(action);
            break;
        case faults_slice_1.FAULTS_GOT_INBOX_DATA:
            next(action);
            faultsAdapter.handleGotInboxData(api)(api.dispatch)(action);
            break;
        case faults_slice_1.FAULTS_NEEDS_MORE_INBOX_DATA:
            faultsAdapter.handleNeedsMoreFaultsInboxDataAction(api)(action);
            next(action);
            break;
        case faults_slice_1.FAULTS_SET_SEVERITY_FILTERS:
            faultsAdapter.handleFaultsInboxFaultTypeFilter(api)(action);
            next(action);
            break;
        case faults_slice_1.FAULTS_SET_MORE_FILTERS:
            faultsAdapter.handleFaultsInboxMoreFilters(api)(action);
            next(action);
            break;
        case faults_slice_1.FAULTS_NEEDS_INBOX_DATA_BY_DATE_RANGE:
            faultsAdapter.handleFaultsInboxDateRangeFilter(api)(action);
            next(action);
            break;
        case faults_slice_1.FAULTS_NEEDS_INBOX_DATA_CSV:
            faultsAdapter.handleNeedsFaultsInboxCsvDataAction(api)(action);
            next(action);
            break;
        case faults_slice_1.FAULTS_SET_IS_RESOLVED_VIEW:
            faultsAdapter.handleFaultsInboxIsResolvedFilter(api)(action);
            next(action);
            break;
        case faults_slice_1.FAULTS_HANDLE_RESOLVE_FAULTS_ACTION:
            faultsAdapter.handleResolveFaults(api)(action);
            next(action);
            break;
        default: next(action);
    }
}; }; }; };
exports.composeFaultsMiddleware = composeFaultsMiddleware;
exports.default = (0, exports.composeFaultsMiddleware)(faults_api_1.default);
